module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p'), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
    staticClass: "Epigram ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("Men make their own history, but they do not make it just as they "), _c('br'), _vm._v("please; they do not make it under circumstances chosen by "), _c('br'), _vm._v("themselves, but under circumstances directly encountered, given "), _c('br'), _vm._v("and transmitted from the past.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-body-after-subhead ParaOverride-3"
  }, [_c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v("—Karl ")]), _c('span', {
    staticClass: "attribution _idGenCharOverride-1"
  }, [_vm._v("Marx")]), _c('span', {
    staticClass: "Text-body CharOverride-10"
  }, [_vm._v(", ")]), _c('span', {
    staticClass: "Text-body CharOverride-12"
  }, [_vm._v("The Eighteenth Brumaire of Louis Bonaparte")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76a40a58","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/epi2.vue
// module id = 75
// module chunks = 0